import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import './TypingIndicator.css';

function TypingIndicator() {
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    // Load the Lottie animation
    fetch('/assets/lottie/typing-indicator.json')
      .then(response => response.json())
      .then(data => setAnimationData(data))
      .catch(error => console.error('Error loading Lottie animation:', error));
  }, []);

  return (
    <div className="typing-indicator-container">
      <div className="typing-indicator-content">
        <span className="typing-indicator-text">Jaimee is typing</span>
        {animationData && (
          <div className="typing-indicator-animation">
            <Lottie
              animationData={animationData}
              loop={true}
              style={{ width: 50, height: 35 }}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default TypingIndicator;
